import React from 'react';
import { MenuItem, FormControl, Select, InputLabel } from '@mui/material';
import Arrow from '@mui/icons-material/KeyboardArrowDown';
import useTranslation from 'Hooks/useTranslation';
import style from './style';

export default function SelectVariants({ title, options = [], setData = () => {} }) {
  const { t } = useTranslation();
  options = [t('Generic.All'), ...options];

  const canvas = document.createElement('canvas');
  const context = canvas.getContext('2d');
  context.font = 'var(--app-font)' || getComputedStyle(document.body).font;
  const textLength = context.measureText(title).width;
  // (Text Length + Expected width of drop down arrow) * arbitrary conversion unit to pixels.
  const controlLength = (textLength + 35) * 1.55;

  return (
    <FormControl
      sx={{
        minWidth: controlLength,
        marginLeft: '1.5rem',
      }}
    >
      <InputLabel id="status" color="MexlogGreen">
        {title}
      </InputLabel>
      <Select
        sx={style.dropDownStyle}
        defaultValue=""
        onChange={e => {
          const currentValue = e.target.value;
          if (currentValue === options[0]) {
            setData('');
            return;
          }
          setData(currentValue);
        }}
        IconComponent={Arrow}
      >
        {options.map((option, index) => (
          <MenuItem
            key={index > 0 ? option + index : ''}
            value={index > 0 ? option : options[0]}
            sx={{ width: '140%' }}
          >
            {option}
          </MenuItem>
        ))}
      </Select>
    </FormControl>
  );
}
